import { render, staticRenderFns } from "./weekList.vue?vue&type=template&id=f2a134bc&scoped=true&"
import script from "./weekList.vue?vue&type=script&lang=js&"
export * from "./weekList.vue?vue&type=script&lang=js&"
import style0 from "./weekList.vue?vue&type=style&index=0&id=f2a134bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a134bc",
  null
  
)

export default component.exports